module.exports = __webpack_public_path__ + "img/1f392.c47195c.svg";